import { jsx as r, jsxs as v } from "react/jsx-runtime";
import * as o from "@radix-ui/react-popover";
import { forwardRef as l } from "react";
const P = o.Root, m = o.Trigger, g = o.Anchor, h = o.Portal, f = o.Close, x = o.Arrow, b = l(function({ className: e, withArrow: t, sideOffset: a = 6, children: s, ...n }, i) {
  return /* @__PURE__ */ r(o.Portal, { children: /* @__PURE__ */ v(
    o.Content,
    {
      ref: i,
      sideOffset: a,
      className: ["ls-popover-content", e].filter(Boolean).join(" "),
      style: {
        backgroundColor: "var(--bg-elevated)",
        border: "1px solid var(--border-strong)",
        borderRadius: "var(--radius-lg)",
        boxShadow: "var(--shadow-md)",
        color: "var(--text-primary)",
        padding: "var(--space-3)",
        minWidth: 200,
        maxWidth: 360,
        zIndex: "var(--z-popover)",
        fontSize: "var(--text-sm)"
      },
      ...n,
      children: [
        s,
        t ? /* @__PURE__ */ r(o.Arrow, { width: 10, height: 5, style: { fill: "var(--bg-elevated)" } }) : null
      ]
    }
  ) });
}), w = o.Root;
export {
  w as P,
  g as a,
  x as b,
  f as c,
  b as d,
  h as e,
  P as f,
  m as g
};
//# sourceMappingURL=Popover-0tE5g_sZ.js.map
